import { render, staticRenderFns } from "./cta-credit.vue?vue&type=template&id=6622aab2&"
import script from "./cta-credit.vue?vue&type=script&lang=js&"
export * from "./cta-credit.vue?vue&type=script&lang=js&"
import style0 from "./cta-credit.vue?vue&type=style&index=0&id=6622aab2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports